import WRTCServerSummary from './WRTCServerSummary.vue'
export default WRTCServerSummary

export enum StatusColor {
  RED = '#cc4435',
  GREEN = '#9bc53d',
  GRAY = 'gray'
}